﻿document.addEventListener("DOMContentLoaded", function() {
    const scrollToTopBtn = document.getElementById('backToTopBtn');
    if (scrollToTopBtn !== null) {
        scrollToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }   
});